import OriginalTabs from './Tabs.svelte';
import OriginalTab from './Tab.svelte';
import Icon from '../icon/Icon.svelte';
const Tabs = OriginalTabs;
Tabs.Tab = OriginalTab;
Tabs.Tab.Icon = Icon;
export default Tabs;
